module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-1x1-8f3fb700af77b110bb638f80bf4d3849.jpg";